const ACTIVE_CLASS_MENU = 'Header__menu--active';

const openMenuButton = document.getElementById('toggle');
const closeMenuButton = document.getElementById('closeMenuButton');
const navigation = document.querySelector('.Header__menu');

const closeAllNavigations = () => {
    document.querySelectorAll('.MegaNav ul.open').forEach((nav) => nav.classList.remove('open'));
};

const query = window.matchMedia('(max-width: 1024px)');

const handleSetOverflow = () => {
    if (query.matches) {
        if (!navigation.classList.contains(ACTIVE_CLASS_MENU)) {
            document.documentElement.style.overflowY = 'auto';
            closeAllNavigations();
        } else {
            document.documentElement.style.overflowY = 'hidden';
        }
    } else {
        document.documentElement.style.overflowY = 'auto';
    }
};

const toggleMenu = () => {
    navigation?.classList.toggle(ACTIVE_CLASS_MENU);

    handleSetOverflow();
};

openMenuButton?.addEventListener('click', toggleMenu);
closeMenuButton?.addEventListener('click', toggleMenu);

query.addEventListener('change', handleSetOverflow);
